import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import {
  ClpPopulation,
  ClpSaleBury,
  HighCommissionBoosting,
  ProductCardDiscountAmount,
} from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      {
        newName: HighCommissionBoosting.NAME,
        oldNameMatcher: /^plp_hc_boosting/m,
      },
      {
        newName: ClpSaleBury.NAME,
        oldNameMatcher: /^clp_sale_bury/m,
      },
      {
        newName: ClpPopulation.NAME,
        oldNameMatcher: /^clp_population/m,
      },
      {
        newName: ProductCardDiscountAmount.NAME,
        oldNameMatcher: /^plp_productcard_discount_amount/m,
      },
    ],
  });
};
